import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const brands = [
  { 
    name: "LG", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/LG_symbol.svg/800px-LG_symbol.svg.png"
  },
  { 
    name: "Sony", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Sony_logo.svg/800px-Sony_logo.svg.png"
  },
  { 
    name: "Samsung", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Samsung_Logo.svg/800px-Samsung_Logo.svg.png"
  },
  { 
    name: "Lenovo", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Lenovo_logo_2015.svg/800px-Lenovo_logo_2015.svg.png"
  },
  { 
    name: "Apple", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Apple_logo_black.svg/800px-Apple_logo_black.svg.png"
  },
  { 
    name: "Dyson", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1f/Dyson_logo.svg/800px-Dyson_logo.svg.png"
  },
  { 
    name: "Epson", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Epson_logo.svg/800px-Epson_logo.svg.png"
  },
  { 
    name: "Canon", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Canon_wordmark.svg/800px-Canon_wordmark.svg.png"
  },
  { 
    name: "HP", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/HP_logo_2012.svg/800px-HP_logo_2012.svg.png"
  },
  { 
    name: "JBL", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/JBL_logo.svg/800px-JBL_logo.svg.png"
  },
  { 
    name: "Xiaomi", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Xiaomi_logo_%282021-%29.svg/800px-Xiaomi_logo_%282021-%29.svg.png"
  },
  { 
    name: "OnePlus", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/OnePlus_logo.svg/800px-OnePlus_logo.svg.png"
  },
  { 
    name: "Asus", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/ASUS_Logo.svg/800px-ASUS_Logo.svg.png"
  },
  { 
    name: "MSI", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/MSI_Logo.svg/800px-MSI_Logo.svg.png"
  },
  { 
    name: "Microsoft", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Microsoft_logo_%282012%29.svg/800px-Microsoft_logo_%282012%29.svg.png"
  },
  { 
    name: "Nintendo", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/Nintendo.svg/800px-Nintendo.svg.png"
  },
  { 
    name: "Toshiba", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Toshiba_logo.svg/800px-Toshiba_logo.svg.png"
  },
  { 
    name: "Xerox", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Xerox_Logo.svg/800px-Xerox_Logo.svg.png"
  },
  { 
    name: "Western Digital", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Western_Digital_logo.svg/800px-Western_Digital_logo.svg.png"
  },
  { 
    name: "Seagate", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Seagate_logo.svg/800px-Seagate_logo.svg.png"
  },
  { 
    name: "SanDisk", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/SanDisk_Logo_2007.svg/800px-SanDisk_Logo_2007.svg.png"
  },
  { 
    name: "POCO", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/POCO_logo.svg/800px-POCO_logo.svg.png"
  }
];

// Duplicate brands for seamless infinite scroll
const duplicatedBrands = [...brands, ...brands];

const BrandPartners = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section className="py-16 md:py-24 bg-brand-surface/30" data-testid="brand-partners-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref}>
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="inline-block px-4 py-2 rounded-full bg-brand-primary/20 text-brand-accent text-sm font-medium mb-4">
            Our Partners
          </span>
          <h2 className="font-outfit text-2xl sm:text-3xl font-bold text-white">
            We deal with <span className="gradient-text">Leading Brands</span>
          </h2>
        </motion.div>

        {/* Infinite Marquee */}
        <div className="relative overflow-hidden py-8">
          {/* Gradient Masks */}
          <div className="absolute left-0 top-0 bottom-0 w-16 sm:w-24 bg-gradient-to-r from-[#0B1120] to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-16 sm:w-24 bg-gradient-to-l from-[#0B1120] to-transparent z-10" />
          
          {/* Scrolling Container */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex animate-marquee"
          >
            {duplicatedBrands.map((brand, index) => (
              <div
                key={`${brand.name}-${index}`}
                className="flex-shrink-0 mx-4 sm:mx-6 md:mx-8"
              >
                <div 
                  className="brand-logo flex items-center justify-center px-4 sm:px-6 py-3 sm:py-4 rounded-xl bg-white border border-white/20 hover:border-brand-accent/50 hover:shadow-lg hover:shadow-brand-accent/10 transition-all duration-300 cursor-pointer min-w-[100px] sm:min-w-[130px] h-16 sm:h-20"
                  data-testid={`brand-logo-${brand.name.toLowerCase().replace(/\s+/g, '-')}-${index}`}
                >
                  <img 
                    src={brand.logo} 
                    alt={`${brand.name} logo`}
                    className="h-8 sm:h-10 md:h-12 w-auto object-contain max-w-[90px] sm:max-w-[110px]"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'block';
                    }}
                  />
                  <span 
                    className="font-outfit text-lg sm:text-xl font-bold text-gray-800 hidden"
                  >
                    {brand.name}
                  </span>
                </div>
              </div>
            ))}
          </motion.div>
        </div>

        {/* & Many More text */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mt-8 text-center"
        >
          <span className="font-outfit text-xl sm:text-2xl text-gray-400 italic">
            & Many More...
          </span>
        </motion.div>

        {/* Brand Categories */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="mt-8 flex flex-wrap justify-center gap-3 sm:gap-4"
        >
          {['Consumer Electronics', 'IT Hardware', 'Gaming', 'Storage', 'Accessories'].map((category) => (
            <span
              key={category}
              className="px-3 sm:px-4 py-1.5 sm:py-2 rounded-full bg-white/5 text-gray-400 text-xs sm:text-sm hover:bg-brand-primary/20 hover:text-brand-accent transition-colors cursor-pointer"
            >
              {category}
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default BrandPartners;
